// import React, { memo, useCallback,useState } from 'react';

// import cx from 'classnames';
// import PropTypes from 'prop-types';
// import CSSModule from 'react-css-modules';

// import styles from './ImageSlider.module.scss';

// const ImageSlider = ({ images, showNavs, showBullets }) => {
//   const imageCount = (images && images?.length) || 0;

//   const [index, setIndex] = useState(0);

//   const showNext = useCallback(() => {
//     if (imageCount <= 1) return;
//     setIndex(prev_index => prev_index + 1);
//   }, [imageCount]);

//   const showPrev = useCallback(() => {
//     if (imageCount <= 1) return;
//     setIndex(prev_index => prev_index - 1);
//   }, [imageCount]);

//   const translation = (100 / imageCount) * index;

//   if (imageCount <= 0) {
//     return null;
//   }

//   return (
//     <div styleName="slides-container" onClick={showNavs ? null : showNext}>
//       <div styleName="transparent-bg"></div>
//       <div
//         styleName="slideshow-container"
//         style={{
//           width: `${imageCount * 100}%`,
//           transform: `translateX(-${translation}%)`,
//         }}
//       >
//         {images.map((image, i) => (
//           <div
//             styleName="slide"
//             style={{ width: `${100 / imageCount}%` }}
//             key={i}
//           >
//             <img src={image} alt={'loading'} style={{ zIndex: -1 }} />
//           </div>
//         ))}
//       </div>
//       {showNavs && (
//         <>
//           <a
//             styleName="prev"
//             onClick={showPrev}
//             style={{ display: index === 0 ? 'none' : 'block' }}
//           >
//             &#10094;
//           </a>
//           <a
//             styleName="next"
//             onClick={showNext}
//             style={{
//               display: index + 1 === imageCount ? 'none' : 'block',
//             }}
//           >
//             &#10095;
//           </a>
//         </>
//       )}

//       {showBullets && (
//         <div styleName="dot-container">
//           {images?.map((_, i) => (
//             <span
//               styleName={cx('dot', {
//                 active: index === i,
//               })}
//               key={i}
//             ></span>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// ImageSlider.propTypes = {
//   images: PropTypes.array,
//   showBullets: PropTypes.bool,
//   showNavs: PropTypes.bool,
// };

// ImageSlider.defaultProps = {
//   images: [],
//   showBullets: false,
//   showNavs: false,
// };

// export default memo(CSSModule(ImageSlider, styles, { allowMultiple: true }));
import React, { memo, useCallback, useState } from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';
import CSSModule from 'react-css-modules';

import LoadingBG from '../../assets/images/LoadingBGImage.webp';
import MiniLogo from '../../assets/images/MiniLogo.svg';
import styles from './ImageSlider.module.scss';
import NO_IMAGE_FALLBACK from '../../assets/images/NoCouponImage.webp';

/**
 * DESIGN UPDATE: each slide now tracks its own load status —
 * 'loading' | 'loaded' | 'error'. While 'loading', the slide shows
 * LoadingBGImage with MiniLogo pulsing on top. If the photo actually fails
 * to load, the slide falls back to the same NoCouponImage graphic used
 * elsewhere for "no image" — instead of exposing the browser's native tiny
 * broken-image icon. All slider mechanics (index state, prev/next, bullets)
 * are unchanged.
 */
const ImageSlider = ({ images, showNavs, showBullets, altText }) => {
  const imageCount = (images && images?.length) || 0;

  const [index, setIndex] = useState(0);
  const [statusMap, setStatusMap] = useState({});

  const showNext = useCallback(() => {
    if (imageCount <= 1) return;
    setIndex(prev_index => prev_index + 1);
  }, [imageCount]);

  const showPrev = useCallback(() => {
    if (imageCount <= 1) return;
    setIndex(prev_index => prev_index - 1);
  }, [imageCount]);

  const markStatus = useCallback((i, status) => {
    setStatusMap(prev => (prev[i] === status ? prev : { ...prev, [i]: status }));
  }, []);

  const translation = (100 / imageCount) * index;

  if (imageCount <= 0) {
    return null;
  }

  return (
    <div styleName="slides-container" onClick={showNavs ? null : showNext}>
      <div styleName="transparent-bg"></div>
      <div
        styleName="slideshow-container"
        style={{
          width: `${imageCount * 100}%`,
          transform: `translateX(-${translation}%)`,
        }}
      >
        {images.map((image, i) => (
          <div
            styleName="slide"
            style={{ width: `${100 / imageCount}%` }}
            key={i}
          >
            <img
              src={image}
              alt={'loading'}
              style={{ zIndex: -1 }}
              onError={e => {
                e.target.onerror = null;
                e.target.src = NO_IMAGE_FALLBACK;
              }}
            />
          </div>
        ))}
      </div>
      {showNavs && (
        <>
          <a
            styleName="prev"
            onClick={showPrev}
            style={{ display: index === 0 ? 'none' : 'block' }}
          >
            &#10094;
          </a>
          <a
            styleName="next"
            onClick={showNext}
            style={{
              display: index + 1 === imageCount ? 'none' : 'block',
            }}
          >
            &#10095;
          </a>
        </>
      )}

      {showBullets && (
        <div styleName="dot-container">
          {images?.map((_, i) => (
            <span
              styleName={cx('dot', {
                active: index === i,
              })}
              key={i}
            ></span>
          ))}
        </div>
      )}
    </div>
  );
};

ImageSlider.propTypes = {
  images: PropTypes.array,
  showBullets: PropTypes.bool,
  showNavs: PropTypes.bool,
  altText: PropTypes.string,
};

ImageSlider.defaultProps = {
  images: [],
  showBullets: false,
  showNavs: false,
  altText: '',
};

export default memo(CSSModule(ImageSlider, styles, { allowMultiple: true }));